import { ICommandBase } from '@/commands/interface/iCommandBase';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { TableCellInfo2 } from '@/model/document2/page/surface/design/layer/table/tableCellInfo2';
import { ArrayHelper } from '@/helper/arrayHelper';

// 表レイヤーのセル削除コマンド
export class DeleteTableCellCommand implements ICommandBase
{
    private layer! : TableLayer;
    private doneCallback! : () => void;

    private row : number = -1;
    private column : number = -1;

    private isDeleteRow : boolean = false;
    private isDeleteColumn : boolean = false;

    private orgLayerWidth : number = 0;
    private orgLayerHeight : number = 0;

    private orgMap : Array<Array<TableCellInfo2>> = new Array();

    constructor(layer : TableLayer, row : number, column : number, isDeleteRow : boolean, isDeleteColumn : boolean, doneCallback : () => void)
    {
        this.layer = layer;
        this.doneCallback = doneCallback;

        this.row = row;
        this.column = column;

        this.isDeleteRow = isDeleteRow;
        this.isDeleteColumn = isDeleteColumn;

        this.orgLayerWidth = layer.width;
        this.orgLayerHeight = layer.height;

        this.orgMap = this.cloneCellInfoMap();
    }

    private cloneCellInfoMap()
    {
        var array = new Array();

        for(var r = 0; r < this.layer.row; ++r)
        {
            array.push(new Array());
            for(var c = 0; c < this.layer.column; ++c)
            {
                var info = this.layer.getCellInfo(r, c);
                array[r].push(info.clone());
            }
        }

        return array;
    }

    public do() : void
    {
        this.doCore();
        
        this.doneCallback();
    }

    public undo() : void
    {
        // レイヤー長さ・高さ復帰
        this.layer.width = this.orgLayerWidth;
        this.layer.height = this.orgLayerHeight;
        // セル情報復帰
        this.layer.cellInfoMap = this.orgMap;

        this.doneCallback();
    }

    public redo() : void
    {
        this.doCore();
        
        this.doneCallback();
    }

    private doCore()
    {
        var orgCellInfo = this.layer.getCellInfo(this.row, this.column);
        // 幅(mm)
        var orgCellWidth = orgCellInfo.cellWidthNormalized * this.layer.width / 100;
        // 高さ(mm)
        var orgCellHeight = orgCellInfo.cellHeightNormalized * this.layer.height / 100;

        if(this.isDeleteColumn)
        {
            // 列削除
            // 新しいレイヤー幅
            var newLayerWidth = this.layer.width - orgCellWidth;

            // 列削除と列幅調整
            var map : Array<Array<TableCellInfo2>> = new Array();
            for(var r = 0; r < this.layer.row; ++r)
            {
                map.push(new Array());
                for(var c = 0; c < this.layer.column; ++c)
                {
                    if(c != this.column)
                    {
                        var info = this.layer.getCellInfo(r, c).clone();
                        var cellWidth = info.cellWidthNormalized * this.layer.width / 100;
                        info.cellWidthNormalized = cellWidth / newLayerWidth * 100;
                        map[r].push(info);
                    }  
                }
            }
            this.layer.cellInfoMap = map;
            this.layer.width = newLayerWidth;
        }

        if(this.isDeleteRow)
        {
            // 行削除
            // 新しいレイヤー高さ
            var newLayerHeight = this.layer.height - orgCellHeight;

            // 行削除と行高さ調整
            var map : Array<Array<TableCellInfo2>> = new Array();
            var rIndex = 0;
            for(var r = 0; r < this.layer.row; ++r)
            {
                if(r != this.row)
                {
                    map.push(new Array());
                    for(var c = 0; c < this.layer.column; ++c)
                    {
                        var info = this.layer.getCellInfo(r, c).clone();
                        var cellHeight = info.cellHeightNormalized * this.layer.height / 100;
                        info.cellHeightNormalized = cellHeight / newLayerHeight * 100;
                        map[rIndex].push(info);
                    }
                    rIndex++;
                }
            }
            this.layer.cellInfoMap = map;
            this.layer.height = newLayerHeight;
        }

        // カレントを外す
        this.layer.currentRow = -1;
        this.layer.currentColumn = -1;
    }
}